define(['jquery', 'libs/jquery.hoverIntent'], function ($) {
	'use strict';

	var megadrop = {
		// summary:
		//		megadrop
		// description:
		//		Functions for the megadrop.
		// version:
		//		1.0.6


		init: function () {
			if (!Modernizr.touch) {
				this.initHoverIntent();
			} else {
				this.initTouchHover();
			}
			this.initKeyboardNavigation();
		},


		initHoverIntent: function () {
			// summary:
			//		initHoverIntent
			// description:
			//		Add megadrop hover function with the hoverIntent plugin.

			var megaConfig = {
				interval: 300,
				sensitivity: 4,
				over: function () {
					$(this).addClass('megadrop-active');
				},
				timeout: 300,
				out: function () {
					$(this).removeClass('megadrop-active');
				}
			};

			$('.has-megadrop').hoverIntent(megaConfig);

			$('html').removeClass('megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
		},


		initTouchHover: function () {
			// summary:
			//		initTouchHover
			// description:
			//		Fixes so hover works on touch devices.

			$(document).on('click', '.has-megadrop', function () {
				$('.has-megadrop').removeClass('megadrop-active');
				$(this).addClass('megadrop-active');
			});

			$(document).on('click', '.has-megadrop > a', function (e) {
				if (!$(this).parent().hasClass('megadrop-active')) {
					if (e.preventDefault) { e.preventDefault(); } else { e.returnValue = false; }
				}
			});

			$('html').removeClass('megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
		},


		initKeyboardNavigation: function () {
			// summary:
			//		initKeyboardNavigation
			// description:
			//		Add keyboard tab navigation to megadrop.

			$('.has-megadrop').keydown(function (e) {
				if (e.keyCode == 13) {
					if (!$(this).hasClass('megadrop-active')) {
						if (e.preventDefault) { e.preventDefault(); } else { e.returnValue = false; }
						$(this).addClass('megadrop-active');
					}
				}
			});

			$(document).on('focusout', '.has-megadrop', function () {
				var $link = $(this);

				$(this).data('focusOutTimer', setTimeout(function () {
					$link.removeClass('megadrop-active');
				}, 50));
			});

			$(document).on('focusin', '.has-megadrop', function () {
				if ($(this).data('focusOutTimer') !== undefined) {
					clearTimeout($(this).data('focusOutTimer'));
				}
			});
		}
	};


	return megadrop;
});


//////////////////
// WEBPACK FOOTER
// ./libs/megadrop.js
// module id = 13
// module chunks = 0